import styled from 'styled-components';

const PageHeaderActions = styled.div`
  grid-area: actions;
  align-self: center;
  justify-self: end;
`;

export default PageHeaderActions;
